import { render, staticRenderFns } from "./OnayamiDetail.vue?vue&type=template&id=a5d35468&"
import script from "./OnayamiDetail.vue?vue&type=script&lang=ts&"
export * from "./OnayamiDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports